function bankModulebankMaster(){

    let bankMasterService = [
        {
            name: "Bank Master",
            icon: "Bank Master",
            logoName: "MyBank",
            // flag: "voucherRequired",
            displayService: "bankModulebankmaster",
            items: [],
        },
    ]

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/bankmaster-dashboard",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "",
            },
        ];

        return dashboardArr;
    };

    const bankMaster = () => {
        const bankMasterArr = [
            {
                path: "/index/bank-bankmaster",
                name: "Bank Master",
                icon: "Bank Master",
                logoName: "MyBank",
                flag: "",
            },
        ];

        return bankMasterArr;
    };

    let a = dashboard();
    let b = bankMaster();

    bankMasterService[0].items = [...a, ...b];

    return bankMasterService;

}

export default bankModulebankMaster;